function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7241 10H16.4655V11.7241H11.7241V10Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5862 12.5862H17.3276V22.0689H12.5862V12.5862Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1724 22.9312H16.8965V26.3794H15.1724V22.9312Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1897 12.5862H19.0518V22.0689H18.1897V12.5862Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5518 19.9138H33.2759V20.7759H31.5518V19.9138Z",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3276 10H19.9138V11.7241H17.3276V10Z",
  fill: "white"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7759 10H25.5173V11.7241H20.7759V10Z",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1035 24.655H29.8277V27.2412H28.1035V24.655Z",
  fill: "white"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.6552 22.0689V12.5862H19.9138V22.0689H24.6552ZM23.7931 16.0345H21.638V15.1724H23.7931V16.0345ZM23.7931 14.3103H21.638V13.4483H23.7931V14.3103Z",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1035 32.4138H29.8277V35H28.1035V32.4138Z",
  fill: "white"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2415 19.4827C27.2415 19.9581 27.6281 20.3447 28.1035 20.3447C28.579 20.3447 28.9656 19.9581 28.9656 19.4827V18.6206H27.2415V19.4827Z",
  fill: "white"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M33.276 16.8965H25.5174V22.4999C25.5174 22.7383 25.3247 22.931 25.0863 22.931H22.9312V23.793H33.276V21.6379H31.1208C30.8824 21.6379 30.6898 21.4452 30.6898 21.2068V19.4827C30.6898 19.2443 30.8824 19.0517 31.1208 19.0517H33.276V16.8965ZM29.8277 19.4827C29.8277 20.284 29.2764 20.953 28.5346 21.1456V22.0689H29.3967V22.931H26.8105V22.0689H27.6725V21.1456C26.9307 20.953 26.3794 20.284 26.3794 19.4827V18.1896C26.3794 17.9512 26.5721 17.7586 26.8105 17.7586H29.3967C29.635 17.7586 29.8277 17.9512 29.8277 18.1896V19.4827Z",
  fill: "white"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M10 22.9312V35.0001H22.069V22.9312H17.7586V26.8105C17.7586 27.0488 17.5659 27.2415 17.3276 27.2415H14.7414C14.503 27.2415 14.3103 27.0488 14.3103 26.8105V22.9312H10ZM13.5746 28.2299C13.7431 28.0613 14.0155 28.0613 14.1841 28.2299L15.4772 29.523L14.8677 30.1324L14.3103 29.5751V32.4139H13.4483V29.5751L12.8909 30.1324L12.2815 29.523L13.5746 28.2299ZM19.4828 34.138H12.5862V33.276H19.4828V34.138ZM18.4944 28.2299L19.7875 29.523L19.178 30.1324L18.6207 29.5751V32.4139H17.7586V29.5751L17.2013 30.1324L16.5918 29.523L17.8849 28.2299C18.0534 28.0613 18.3259 28.0613 18.4944 28.2299Z",
  fill: "white"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6898 27.6723C30.6898 27.9106 30.4971 28.1033 30.2587 28.1033H27.6725C27.4342 28.1033 27.2415 27.9106 27.2415 27.6723V24.655H22.9312V34.9999H27.2415V31.9826C27.2415 31.7443 27.4342 31.5516 27.6725 31.5516H30.2587C30.4971 31.5516 30.6898 31.7443 30.6898 31.9826V34.9999H35.0001V24.655H30.6898V27.6723Z",
  fill: "white"
});
function SvgPackagesIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesIco);
export default __webpack_public_path__ + "static/media/packages_ico.7eabc0762c798904544893c7e298f3d8.svg";
export { ForwardRef as ReactComponent };